import { convertMilliseconds } from "@src/utils/formatters";

const steps: any = {
  1: "Customer Info",
  2: "Additional Info",
  3: "Material Info",
  4: "Booking Details",
  5: "Order Summary",
  6: "Payment Info",
  7: "Checkout",
  8: "Thank You",
};

export const syncCart = async ({ data, duration, meta }: any) => {
  const url = `${process.env.NEXT_PUBLIC_REDIRECT_URL}api/trackers/cart`;
  if (!data.email && !data.phoneNumber) return;
  const eid = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...data,
      meta: {
        duration: convertMilliseconds(duration),
        step: steps[meta.step],
        context: meta.context,
      }
    })
  })
    .then(response => response.json())
    .then(response => {
      const engagementId = response.id || null;
      return engagementId
    })
    .catch(error => {
      // handle error
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    });
  // eslint-disable-next-line consistent-return
  return eid;
}

export const destroyCart = async (cartId: string) => {
  const url = `${process.env.NEXT_PUBLIC_REDIRECT_URL}api/trackers/cart-end/${cartId}`;
  fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then(response => response.json())
  .catch(error => {
    // handle error
    // eslint-disable-next-line no-console
    console.error(error);
  });
}
